var React = require('react');

function ArrowNE (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1, .cls-2 {\n                fill: none;\n                stroke-miterlimit: 8;\n            }\n\n            .cls-1 {\n                stroke-linecap: square;\n            }\n            \n            .cls-2 {\n                stroke-linecap: round;\n            }\n        ")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M10.73,7.21l0-6.67L4.1.5","key":0}),React.createElement("path",{"className":"cls-1","d":"M.71,10.48l9.5-9.39","key":1}),React.createElement("path",{"className":"cls-2","d":"M10.77.54l-.56.55","key":2})]))]);
}

ArrowNE.defaultProps = {"viewBox":"0 0 11.27 11.19","width":"16","height":"16","stroke":"#231f20"};

module.exports = ArrowNE;

ArrowNE.default = ArrowNE;
